import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getDokumenWeiver = 'data-weiver/';
const putDataWeiver = 'data-weiver/';
const getDataWeiver = 'data-weiver';

class DataWeiverService {
    getDataWeiver(currentPage, pageSize, filter, id_waiver) {
        return axios.get(
            API_URL + getDataWeiver + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&id_waiver' + id_waiver ,
            {
                headers: authHeader()
            });
    }

    getDokumenWeiver(idWeiver) {
        return axios.get(
            API_URL + getDokumenWeiver + idWeiver, {
            headers: authHeader()
        });

    }

    putStatusPengajuan(formData) {
        return axios.put(
            API_URL + putDataWeiver + formData.idWeiver,
            formData,
            { headers: authHeader() }
        )
    }


}

export default new DataWeiverService();